import { useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import EudrDashboardService from 'src/modules/3rd-party-management/apis/admin/EudrDashboardService';

export const EUDR_RISK_HEATMAP_QUERY_KEY = '3rd-party-management-fetch-eudr-risk-heatmap';

const useRiskHeatmap = ({
    t,
}) => {
    return useQuery({
        queryKey: [EUDR_RISK_HEATMAP_QUERY_KEY],
        queryFn: async () => {
            const service = EudrDashboardService.getInstance();

            return await service.fetchRiskHeatmap();
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: (error) => {
            if (process.env.NODE_ENV === 'development') console.error(error);

            toast(t('An error occurred while fetching EUDR risk heatmap data.'), {
                type: 'error',
            });
        },
    });
};

export default useRiskHeatmap;
